import { Controller } from "@hotwired/stimulus";

// Points a turbo-frame at a URL built from the value that just changed, for a
// part of the screen that only makes sense once something has been chosen.
export default class extends Controller {
  static values = { frame: String, template: String };

  load(event) {
    const frame = document.getElementById(this.frameValue);
    const value = event.target.value;
    if (!frame || !value) return;

    frame.src = this.templateValue.replace("__value__", encodeURIComponent(value));
  }
}
